import type { VesselChangeScope } from './types/vesselChanges';

/**
 * React Query keys for the vessel changes page. `alerts` sits under `all`, so every
 * update or dismiss on the page (which invalidates `all`) reads the alerts again too.
 */
export const vesselChangesQueryKeys = {
  all: ['vessel-changes'] as const,
  list: (scope: VesselChangeScope) => [...vesselChangesQueryKeys.all, 'list', scope] as const,
  alerts: () => [...vesselChangesQueryKeys.all, 'alerts'] as const,
};
